import React from "react";
import styled from "@emotion/styled";
import { Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { auth } from "../common/utils/auth";
import OptiFleetLogo from "../common/assets/OptifleetLogo";
import GoogleLogo from "../common/assets/GoogleLogo";
import {
    SPACING_1,
    SPACING_8,
    SPACING_12,
    SPACING_16,
    SPACING_24,
    SPACING_60,
} from "../common/styles/spacing";
import { BOX_SHADOW_1 } from "../common/styles/box-shadow";
import { GRAY_500 } from "../common/styles/colors";
import { addAlert, Alert } from "../Alerts/alertsSlice";
import { captureException } from "../common/utils/sentry";

const LoginDiv = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;

  #logo_optifleet {
    width: 40%;
    margin: ${SPACING_60};
  }
`;

const LoginButton = styled(Button)`
  display: flex;
  max-width: unset;
  margin-top: ${SPACING_16};
  padding: ${SPACING_8} ${SPACING_16};
  box-shadow: ${BOX_SHADOW_1};

  #icon_google {
    height: ${SPACING_24};
  }
`;

const LoginText = styled.span`
  color: ${GRAY_500};
  font-weight: bold;
  letter-spacing: ${SPACING_1};
  text-transform: none;
  padding-left: ${SPACING_12};
`;

export default () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handleGoogleLoginClick = async () => {
        const ERROR_MESSAGE: Alert = {
            text: t("login.errorMessage"),
            type: "error",
        };

        try {
            const { user } = await auth.loginWithGSuite();

            if (!user) {
                dispatch(addAlert(ERROR_MESSAGE));
            }
        } catch (e) {
            dispatch(addAlert(ERROR_MESSAGE));
            captureException(e);
        }
    };

    return (
        <LoginDiv>
            <OptiFleetLogo />
            <LoginButton onClick={handleGoogleLoginClick}>
                <GoogleLogo />
                <LoginText>{t("login.google")}</LoginText>
            </LoginButton>
        </LoginDiv>
    );
};
